import React, { Component } from 'react'
import { withTranslation } from "react-i18next";
import { restbaseurl } from '../../../globals/constants';
import { RestDataSource } from '../../../utils/RestDataSource';
import Select from "react-select";
import ConfirmationModal from '../../../globals/uicomps/ConfirmationModal';
import UserInfo from '../../../models/UserInfo';

class ResidenceAssignmentTableRow extends Component {
     constructor(props) {
          super(props);
          this.state = {
               caseRowloading: false,
               dummy: false,
               vendorId: '',
               showConfirmationModal: false,
               subheading: '',
               unAssign: false,
               vendorOptions: [],
               isConfirmationCallback:false,
               currentVendorId: this.props.completeState ? this.props.completeState.vendorId : null
          }
     }


     onVendorChange = (event) => {
          let { checkCode } = this.props;
          this.setState({
               vendorLabel: event.label,
               vendorId: event.value,
               showConfirmationModal: true,
               subheading: `Do you want to assign  ${event.label} to this ${checkCode} check`
          })
     }

     confirmSuccessCallback = () => {
          if(this.state.isConfirmationCallback) return;
          this.setState({isConfirmationCallback: true});
          let { checkCode } = this.props;
          const { currentVendorId } = this.state;
          let action = 'assignVendor';
          if (checkCode === 'residence') {
               action = 'reAssignVendor'
          } else if (checkCode === 'cibil' && currentVendorId) {
               action = 'reAssignVendor'
          }
          if (this.state.unAssign) {
               this.unAssignVendor()
          } else {
               this.saveResidence = new RestDataSource(
                    `${restbaseurl}/${checkCode}/${action}`
               );
               this.setState({ loading: true }, () => {
                    this.saveResidence.GetData(
                         data => {
                              if (data.status === true) {
                                   this.setState({
                                        showConfirmationModal: false,
                                        cbRender: this.props.cbRender()
                                   })
                              }
                         },
                         {
                              "vendorId": this.state.vendorId,
                              'id': this.props.unAssignedObjList.id,
                              userId: this.userId

                         },
                         "POST"
                    );
               });
          }
     }

     unAssignVendorConfirmation = () => {
          this.setState({
               showConfirmationModal: true,
               unAssign: true,
               subheading: `Do you want to Unassign vendor to this case `
          })
     }

     unAssignVendor = () => {
          let { checkCode } = this.props;
          this.unAssign = new RestDataSource(
               `${restbaseurl}/${checkCode}/unassignVendor`
          );
          this.setState({ loading: true }, () => {
               this.unAssign.GetData(
                    data => {
                         if (data.status === true) {
                              this.setState({
                                   showConfirmationModal: false,
                                   unAssign: false,
                                   cbRender: this.props.cbRender()
                              })
                         }
                    },
                    {
                         "id": this.props.unAssignedObjList.id, userId: UserInfo.getUserid()
                    },
                    "POST"
               );
          });
     }

     render() {
          // let { checkCode } = this.props;
          let unAssignedObjList = this.props.unAssignedObjList
          let vendorAvailableList = this.props.unAssignedObjList.vendorAvailableList
          let vendorOptions = vendorAvailableList.map(vendorObj => {
               return { label: vendorObj.vendorName, value: vendorObj.vendorId };
          });
          let isVendorAvailable = vendorOptions.length
          return (
               <React.Fragment>
                    <tr className="case-row" >
                         <td>{this.props.idx + 1}</td>
                         {/* <td>
                              <div className="straight_td" >{unAssignedObjList.bgvId}</div>
                         </td> */}
                         <td>
                              <div className="straight_td title-hover " >
                                   {unAssignedObjList.caseNumber}
                                   {unAssignedObjList.bgvId ? <div className="icon-details pad10">
                                        <div className="body2 mt5">{unAssignedObjList.caseNumber} -  {unAssignedObjList.bgvId}</div>
                                   </div> : null}
                              </div>
                         </td>
                         {!this.props.chooseVendor ? <td>
                              <div className="straight_td" >{unAssignedObjList.assignedDate}</div>
                         </td> : null}
                         <td>
                              <div className="straight_name" title={unAssignedObjList.name} >{unAssignedObjList.name}</div>
                         </td>
                         <td>
                              <div className="case-icons wordbreak" style={{ width: "200px" }}>
                                   {unAssignedObjList.address}
                              </div>
                         </td>
                         <td>
                              <div className="straight_td" >
                                   {unAssignedObjList.status}
                              </div>
                         </td>
                         {(this.props.chooseVendor && isVendorAvailable) ? <td>
                              <div className="straight_vendor" >
                                   <Select
                                        id="vendorId"
                                        styles={{
                                              control: (provided, state) => ({
                                                ...provided,
                                                border: "1px solid #D4DBFF",
                                                borderRadius: 8,
                                                 
                                              }),
                                            }}
                                        options={vendorOptions}
                                        onChange={this.onVendorChange}
                                   ></Select>
                              </div>
                         </td> : null}
                         {!isVendorAvailable ? <td>No Vendor  Available</td> : null}
                         {(!this.props.chooseVendor && isVendorAvailable) ? <React.Fragment>
                              <td style={{ width: "200px" }}>
                                   <Select
                                        id="vendorId"
                                        styles={{
                                              control: (provided, state) => ({
                                                ...provided,
                                                border: "1px solid #D4DBFF",
                                                borderRadius: 8,
                                                 
                                              }),
                                            }}
                                        options={vendorOptions}
                                        value=''
                                        onChange={this.onVendorChange}
                                   ></Select>
                              </td>
                              <td>
                                   <img alt="icon-close" src={'/images/icons/icon-close.svg'} className="remove_vendor pointer" onClick={this.unAssignVendorConfirmation} style={{ marginTop: "7px" }} />
                              </td> </React.Fragment> : null}

                    </tr>
                    <ConfirmationModal
                         show={this.state.showConfirmationModal}
                         heading="Are you sure ?"
                         subheading={this.state.subheading}
                         successButtonText="Yes"
                         failureButtonText="No"
                         successCallback={() => { this.confirmSuccessCallback() }}
                         failureCallback={() => { this.setState({ showConfirmationModal: false }) }}
                         closeCallback={() => { this.setState({ showConfirmationModal: false }) }}
                    ></ConfirmationModal>
               </React.Fragment>
          )
     }
}
export default withTranslation("translations")(ResidenceAssignmentTableRow);

